function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "rewards/word-wizard");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("polygon", {
  id: "path-1",
  points: "7.03125e-05 0 45 0 45 47.9999652 7.03125e-05 47.9999652"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "path-3",
  points: "7.03125e-05 0 45 0 45 44.5217043 7.03125e-05 44.5217043"
}));

var _ref5 = /*#__PURE__*/React.createElement("g", {
  id: "Product",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Dashboard-Rewards-1440",
  transform: "translate(-217.000000, -489.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "rewards/word-wizard",
  transform: "translate(217.000000, 489.000000)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-13"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-3"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-2",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-1"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-2"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813203,47.9999652 L4.21882031,47.9999652 C1.88901563,47.9999652 7.03125e-05,46.1310957 7.03125e-05,43.8260522 L7.03125e-05,4.17387826 C7.03125e-05,1.86883478 1.88901563,-3.47826087e-05 4.21882031,-3.47826087e-05 L40.7813203,-3.47826087e-05 C43.111125,-3.47826087e-05 45.0000703,1.86883478 45.0000703,4.17387826 L45.0000703,43.8260522 C45.0000703,46.1310957 43.111125,47.9999652 40.7813203,47.9999652",
  id: "Fill-1",
  fill: "#00093B",
  mask: "url(#mask-2)"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group-6"
}, /*#__PURE__*/React.createElement("mask", {
  id: "mask-4",
  fill: "white"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path-3"
})), /*#__PURE__*/React.createElement("g", {
  id: "Clip-5"
}), /*#__PURE__*/React.createElement("path", {
  d: "M40.7813203,44.5217043 L4.21882031,44.5217043 C1.88901563,44.5217043 7.03125e-05,42.6528348 7.03125e-05,40.3477913 L7.03125e-05,4.17387826 C7.03125e-05,1.86883478 1.88901563,-3.47826087e-05 4.21882031,-3.47826087e-05 L40.7813203,-3.47826087e-05 C43.111125,-3.47826087e-05 45.0000703,1.86883478 45.0000703,4.17387826 L45.0000703,40.3477913 C45.0000703,42.6528348 43.111125,44.5217043 40.7813203,44.5217043",
  id: "Fill-4",
  fill: "#000F68",
  mask: "url(#mask-4)"
})), /*#__PURE__*/React.createElement("path", {
  d: "M32.6325586,13.5932174 C32.4363867,13.3375652 32.114707,13.206087 31.7902148,13.206087 L25.1745117,13.206087 L25.1407617,13.206087 C21.9120117,13.206087 19.0070508,15.1473043 17.8011914,18.1104348 L12.9425977,30.0485217 L31.9698633,30.0485217 L27.3004102,18.4749565 C27.0824414,17.9354783 27.3331055,17.321913 27.8685352,17.0833043 L32.246543,15.1344348 C32.8318945,14.8735652 33.0477539,14.1333913 32.6325586,13.5932174",
  id: "Fill-7",
  fill: "#0B26C7"
}), /*#__PURE__*/React.createElement("path", {
  d: "M34.3707891,32.7068174 L10.6294219,32.7068174 C9.78145313,32.7068174 9.09379688,32.0268174 9.09379688,31.1878609 C9.09379688,30.3485565 9.78145313,29.6685565 10.6294219,29.6685565 L34.3707891,29.6685565 C35.2187578,29.6685565 35.9060625,30.3485565 35.9060625,31.1878609 C35.9060625,32.0268174 35.2187578,32.7068174 34.3707891,32.7068174",
  id: "Fill-9",
  fill: "#001593"
}), /*#__PURE__*/React.createElement("path", {
  d: "M23.3279648,27.0838609 C23.9003086,27.0838609 24.4350352,26.9301217 24.8962852,26.6647304 C23.9600742,26.1280348 23.3279648,25.1287304 23.3279648,23.9802087 C23.3279648,22.8320348 23.9600742,21.8327304 24.8962852,21.295687 C24.4350352,21.0302957 23.9003086,20.8765565 23.3279648,20.8765565 C21.5947617,20.8765565 20.1909727,22.2654261 20.1909727,23.9802087 C20.1909727,25.6949913 21.5947617,27.0838609 23.3279648,27.0838609",
  id: "Fill-11",
  fill: "#FFDC4A"
})))));

var SvgWordWizard = function SvgWordWizard(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "45px",
    height: "48px",
    viewBox: "0 0 45 48",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWordWizard, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/word-wizard.9fd685a5.svg";
export { ForwardRef as ReactComponent };